// Условия использования только на английском. Абзац: строка, список: массив строк.
// При существенной правке текста обновляйте TERMS_EFFECTIVE_DATE.
export const TERMS_EFFECTIVE_DATE = 'November 5, 2026';

export const TERMS_SECTIONS = [
  {
    title: 'Agreement to these Terms',
    body: [
      'These Terms of Use (the "Terms") govern your use of the Plannely mobile apps and website at https://plannely.app (together, the "Service"). The Service is provided by SEOTIV ("we", "us").',
      'By creating an account or using the Service, you agree to these Terms. If you do not agree, please do not use the Service. Our Privacy Policy at https://plannely.app/privacy-policy explains how we handle personal data and forms part of how the Service operates.',
    ],
  },
  {
    title: 'The Service',
    body: [
      'Plannely is a personal planner. Depending on your platform, version and plan, it can include tasks, categories, habits, reminders, calendar views, focus and workout tools, and synchronization between your devices.',
      'We may add, change or remove features as the Service develops. If a change significantly reduces a paid feature you are currently paying for, we will try to give you reasonable notice through the app or by other suitable means.',
    ],
  },
  {
    title: 'Your account',
    body: [
      'You sign in using a method offered in the app, such as Google or Apple. You are responsible for keeping access to that account and your devices secure, and for the activity that takes place under your Plannely account. Tell us promptly at support@plannely.app if you believe your account has been accessed without permission.',
      'Please make sure the information you give us is accurate. You should use the Service only as permitted by the laws that apply to you.',
    ],
  },
  {
    title: 'Children and minors',
    body: [
      'If you have not reached the age at which you can enter into a binding agreement where you live, you may use the Service only with the permission and involvement of a parent or legal guardian, who accepts these Terms on your behalf. Section 14 of our Privacy Policy describes how we treat children\'s data.',
    ],
  },
  {
    title: 'Free and paid plans',
    body: [
      'Plannely offers a free plan with usage limits and optional paid subscriptions with higher limits or additional features. The current limits and prices are shown in the app and may change over time. On the free plan, tasks count toward the task limit until you delete them, including completed tasks.',
      'Subscriptions are sold and billed by Apple or Google Play, using the account you purchase with. The following applies, together with the rules of the store:',
      [
        'A subscription renews automatically for the same period at the then-current price unless you cancel it at least 24 hours before the end of the current period, or as the store otherwise requires.',
        'If a free trial is offered, it converts to a paid subscription at the end of the trial unless you cancel in time. The price and trial length are shown before you confirm the purchase.',
        'You manage or cancel a subscription in your Apple or Google Play account. Deleting the app or your Plannely account does not cancel it.',
        'Refunds are handled by the store under its policies. We do not process store payments and do not receive your full payment card details.',
      ],
      'If a subscription ends, your account returns to the free plan. Your data is not deleted because of this, but features and content beyond the free limits, such as additional habits, may be unavailable until you subscribe again.',
    ],
  },
  {
    title: 'Your content',
    body: [
      'You keep all rights to the tasks, notes, habits, workouts and other content you create in the Service ("Your Content"). You give us a limited, non-exclusive, worldwide license to store, process, copy and transmit Your Content only as needed to operate, secure and support the Service for you. We do not use Your Content for advertising and we do not sell it.',
      'You are responsible for Your Content and for having the right to use it. Please keep your own copy of anything that is critically important to you.',
      'If you create a share link for a workout program, anyone who has the link can view and copy that program until the link expires or you revoke it. Only share links with people you trust, and do not put private information into content you share.',
    ],
  },
  {
    title: 'Acceptable use',
    body: [
      'When using the Service, you agree not to:',
      [
        'break the law or infringe the rights of others;',
        'store or share unlawful, harmful or abusive content, including through share links;',
        'gain or try to gain unauthorized access to the Service, other accounts or our systems;',
        'interfere with the Service, overload it, or bypass plan limits and other technical restrictions;',
        'reverse engineer the Service, except where the law allows this despite this restriction;',
        'use automated means to extract data from the Service without our written permission;',
        'resell or commercially redistribute the Service without our written permission.',
      ],
    ],
  },
  {
    title: 'Reminders and availability',
    body: [
      'We work to keep the Service reliable, but reminders and synchronization depend on your device, its settings, your network, and third-party services such as Apple and Google. Notifications may be delayed or may not arrive. Do not rely on the Service as your only reminder for anything where a missed notification could cause harm or serious loss, such as taking medication.',
      'The Service may occasionally be unavailable because of maintenance, updates or events outside our control.',
    ],
  },
  {
    title: 'Health and workouts',
    body: [
      'Workout, focus and habit features are general self-organization tools. They are not medical advice, diagnosis or treatment. Talk to a qualified health professional before starting or changing an exercise routine, especially if you have a health condition. Stop exercising if you feel pain, dizziness or discomfort. You use these features at your own risk, to the extent the law allows.',
    ],
  },
  {
    title: 'Our intellectual property',
    body: [
      'The Service, including its software, design, name and logos, belongs to us or our licensors and is protected by intellectual property laws. We grant you a personal, limited, non-exclusive, non-transferable and revocable license to use the Service for its intended purpose under these Terms. Your Content remains yours.',
      'If you send us feedback or ideas, we may use them without any obligation to you.',
    ],
  },
  {
    title: 'Third-party services',
    body: [
      'The Service relies on third parties for functions such as sign-in, payments, notifications and hosting. Their own terms and privacy policies apply to the services they provide. We are not responsible for the availability or actions of third-party services that we do not control.',
    ],
  },
  {
    title: 'Ending your use of the Service',
    body: [
      'You can stop using the Service at any time and delete your account in the app or by emailing support@plannely.app. Account deletion is described in our Privacy Policy. Remember to cancel any store subscription separately.',
      'We may suspend or close an account if you seriously or repeatedly breach these Terms, if your use creates a risk for the Service or others, or if the law requires it. Where appropriate and permitted, we will tell you why and give you a chance to fix the problem. If we discontinue the Service, we will try to give reasonable advance notice.',
    ],
  },
  {
    title: 'Disclaimer of warranties',
    body: [
      'To the fullest extent permitted by law, the Service is provided "as is" and "as available". We do not promise that it will be uninterrupted, error-free, or suitable for a particular purpose, or that no data will ever be lost. Nothing in these Terms limits warranties or consumer rights that cannot be limited under the law that applies to you.',
    ],
  },
  {
    title: 'Limitation of liability',
    body: [
      'To the fullest extent permitted by law, we are not liable for indirect, incidental, special or consequential damages, or for lost profits, lost data or missed events. For paid plans, our total liability for any claim relating to the Service is limited to the amount you paid for the Service in the 12 months before the event giving rise to the claim. For the free plan, it is limited to the equivalent of USD 50.',
      'These limits do not apply to liability that cannot be excluded or limited by law, such as liability for fraud, intentional wrongdoing, or death or personal injury caused by negligence where the law provides so.',
    ],
  },
  {
    title: 'Apps downloaded from the Apple App Store',
    body: [
      'If you downloaded Plannely from the Apple App Store, these additional terms apply:',
      [
        'These Terms are between you and SEOTIV, not Apple. SEOTIV, not Apple, is solely responsible for the app and its content.',
        'Your license is limited to using the app on Apple-branded devices you own or control, as allowed by the Usage Rules in the Apple Media Services Terms and Conditions.',
        'Apple has no obligation to provide maintenance or support for the app.',
        'If the app fails to conform to an applicable warranty, you may notify Apple and Apple will refund the purchase price, if any. To the maximum extent permitted by law, Apple has no other warranty obligation regarding the app.',
        'Apple is not responsible for addressing claims relating to the app or your use of it, including product liability claims, legal or regulatory compliance claims, consumer protection or privacy claims.',
        'Apple is not responsible for investigating, defending, settling or discharging any third-party claim that the app or your use of it infringes intellectual property rights.',
        'You confirm that you are not located in a country subject to a U.S. Government embargo or designated as a "terrorist supporting" country, and that you are not on any U.S. Government list of prohibited or restricted parties.',
        'You must comply with applicable third-party terms when using the app.',
        'Apple and its subsidiaries are third-party beneficiaries of these Terms and may enforce them against you.',
      ],
    ],
  },
  {
    title: 'Changes to these Terms',
    body: [
      'We may update these Terms as the Service or the law changes. The latest version is always published at https://plannely.app/terms with its effective date. If a change is material, we will try to tell you in advance through the app or by other suitable means. By continuing to use the Service after a change takes effect, you accept the updated Terms. If you do not agree, stop using the Service and delete your account.',
    ],
  },
  {
    title: 'Governing law and disputes',
    body: [
      'Please contact us first so we can try to resolve any issue informally. These Terms are governed by the laws of the country where SEOTIV is established, without regard to conflict-of-law rules. This does not take away any mandatory protection you have under the consumer laws of the country where you live, including your right to bring a claim in the courts available to you under those laws.',
      'If any part of these Terms is found to be unenforceable, the remaining parts continue to apply. If we do not enforce a provision right away, we do not waive our right to enforce it later. You may not transfer your rights under these Terms without our consent. We may transfer ours as part of a reorganization or sale of the Service, without reducing your rights.',
      'We provide translations of these Terms for your convenience. If a translation differs from the English version, the English version prevails, unless the law of your country requires otherwise.',
    ],
  },
  {
    title: 'Contact',
    body: [
      'If you have questions about these Terms, contact us at support@plannely.app.',
    ],
  },
];
